import getByChance from "./getByChance";

const filterNoDublicate = (programsDublicate, region) => {
  let programs__obj = {},
    two_dimensial_arr = [],
    val,
    filterNoDublicatePrograms = [];

  /* Добавление программ в объект с разделением по shortname */
  for (var i = 0; i < programsDublicate.length; i++) {
    val = programsDublicate[i]["shortName"];

    if (!programs__obj.hasOwnProperty(val)) {
      programs__obj[val] = [];
    }

    programs__obj[val].push(programsDublicate[i]);
  }

  /* Добавление разделенных по массивам программ в один общий массив */
  for (let key in programs__obj) {
    if (programs__obj.hasOwnProperty(key)) {
      two_dimensial_arr.push(programs__obj[key]);
    }
  }

  /* Выборка программ путем рандомной функции процентного шанса */
  two_dimensial_arr.forEach((programs) => {
    filterNoDublicatePrograms.push(getByChance(programs, region));
  });

  return filterNoDublicatePrograms;
};

export default filterNoDublicate;
